import styled from 'styled-components';
import { ImageButtonStyled } from '../ImageButtonStyled';
import { rem } from 'polished';

export const ImageButtonStyledOV = styled(ImageButtonStyled)`
    .img-btn-container {
        border: 1px solid ${({ theme }) => theme.colors.grey8};
        color: ${({ theme }) => theme.colors.black};
        text-decoration: none;

        .top {
            h1 {
                font-weight: 700;
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                line-height: ${({ theme }) => theme.lineHeights.h4};
            }
            .sum {
                color: ${({ theme }) => theme.colors.black};
            }
        }

        .description {
            position: relative;
            background-color: ${({ theme }) => theme.colors.black};
            color: ${({ theme }) => theme.colors.white};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            line-height: ${({ theme }) => theme.lineHeights.h5};
            padding: ${rem(8)} ${rem(16)};
            font-weight: ${({ theme }) => theme.fontWeights.textMedium};
            text-transform: uppercase;
            :after {
                display: none;
            }
        }

        &.active {
            .description {
                :after {
                    visibility: visible;
                }
            }
        }

        img {
            top: ${rem(70)};
            max-height: 100%;
        }

        .sum {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            background-color: ${({ theme }) => theme.colors.primary};
            line-height: ${({ theme }) => theme.lineHeights.h5};
        }
    }
`;
